export function download(base64: string, name: string) {
  const link = document.createElement('a');

  document.body.appendChild(link);

  link.setAttribute('type', 'hidden');
  link.href = base64;
  link.download = name;
  link.click();

  document.body.removeChild(link);
}
